<div
  class="d-flex flex-column align-items-stretch flex-shrink-0 bg-white"
  style="width: 100%"
>
  <div
    class="d-flex align-items-center flex-shrink-0 p-3 link-dark text-decoration-none border-bottom"
  >
    <span
      class="btn-close p-0 cursor"
      (click)="onClose()"
      style="width: 16px; height: 16px"
    ></span>
    <h5 class="fw-semibold text-dark-0">การแจ้งเตือน</h5>
  </div>
  <div class="list-group list-group-flush border-bottom scrollarea">
    <div>
      <div
        class="dropdown-item-text d-flex flex-row justify-content-between align-items-center w-100 gap-3"
        style="padding: 1rem 20px 0 20px"
      >
        <div class="text-start">
          <ul class="mb-2 text-dark-0">
            <li style="font-weight: 600">การแจ้งเตือน</li>
          </ul>
          <p class="mb-0 text-dark-0">มีคำขอเบิกวัสดุใหม่เลขที่ 00001</p>
        </div>
        <p class="mb-0 text-grey-light">12 ม.ค. 2567 12:52 น.</p>
      </div>
      <hr />
    </div>
  </div>
</div>
